/**
 * @file ClientOptionsTab.js
 * @description This file contains the ClientOptionsTab component, which is a reusable form for displaying and editing an individual's demographic information.
 */

import style from './ClientList.module.scss';
import ClientSettingSelfRegistration from './ClientSettingSelfRegistration';

const ClientOptionsTab = ({ individualId, clientRecord = null }) => {
    return (
        <form className={style.demographicFormContainer}>
            <div className={`row px-5 pb-5`}>
                <div
                    className={`col-12 col-xs-12 col-md-12 col-lg-12 col-xl-8`}
                    style={{ margin: '0 auto' }}
                >
                    <ClientSettingSelfRegistration
                        clientId={individualId}
                        clientRecord={clientRecord}
                    />
                </div>
            </div>
        </form>
    );
};

export default ClientOptionsTab;
